import React from 'react';

import { format } from 'date-fns';
import styled from 'styled-components';

import { UserManagementUserType } from '../types';

const DateText = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const SenderText = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

type Props = {
  item: UserManagementUserType;
};

const UserManagementTableInvitation = ({ item }: Props) => {
  const date = item?.last_invitation_sent;
  const sentBy = item?.last_invitation_sent_by;

  if (!date) {
    return <span>-</span>;
  }

  const senderLabel = sentBy ? `${sentBy.first_name || ''} ${sentBy.last_name || ''}`.trim() || sentBy.email : '';

  return (
    <div>
      <DateText>{format(new Date(date), 'MMM dd, yyyy hh:mm a')}</DateText>
      {senderLabel && <SenderText>{senderLabel}</SenderText>}
    </div>
  );
};

export default UserManagementTableInvitation;
